<script setup lang="ts">
import { useDropZone } from "@vueuse/core"
import { ref } from "vue"

interface Emits {
  (event: "fileChanged", files: File[]): void
}

const emit = defineEmits<Emits>()

const dropZoneRef = ref<HTMLDivElement | null>(null)

function onDrop(files: File[] | null) {
  if (files && files.length > 0) {
    emit("fileChanged", files)
  }
}

const { isOverDropZone } = useDropZone(dropZoneRef, onDrop)

function handleDragOver(event: DragEvent) {
  event.preventDefault()
  event.stopPropagation()
}
</script>

<template>
  <div
    ref="dropZoneRef"
    class="p-4"
    :class="{ 'bg-teal-100': isOverDropZone }"
    @dragover="handleDragOver"
  >
    <slot>Drag and drop files here</slot>
  </div>
</template>
